var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Show",
    d: "M17.432,4.007,17,4C10.792,4,5.194,8.385,2.091,15.559a1.111,1.111,0,0,0,0,.883l.215.484C5.37,23.64,10.663,27.8,16.568,27.993L17,28c6.211,0,11.809-4.385,14.912-11.559a1.112,1.112,0,0,0,0-.893l-.209-.47C28.625,8.351,23.329,4.2,17.432,4.007Zm-.419,2.227.358.008.4.021c4.8.34,9.206,3.9,11.871,9.736l-.014.036C26.9,22,22.335,25.578,17.388,25.757l-.382.006-.386-.005-.4-.021c-4.647-.329-8.931-3.686-11.612-9.2L4.355,16l.235-.5C7.417,9.66,12.037,6.235,17.014,6.234ZM17,10.17A5.829,5.829,0,1,0,22.867,16,5.848,5.848,0,0,0,17,10.17Zm0,2.235A3.594,3.594,0,1,1,13.383,16,3.606,3.606,0,0,1,17,12.406Z",
    transform: "translate(-2 -4)",
    fill: "#2ebced",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.559d00f7ec0c09ceb8bf448d4efb760c.svg";
export { ForwardRef as ReactComponent };